export function ReportLeftBottom(score: number, type: string) {
    let left = 0;
    let bottom = 0;

    if (score <= 20) {
        left = score - 0.5;
        bottom = 10 + score * 0.3258;
    } else if (score > 20 && score < 30) {
        left = score - 0.5;
        bottom = 9.5 + score * 0.3258;
    } else if (score >= 30 && score <= 40) {
        left = score - 0.5;
        bottom = 9.5 + score * 0.3258;
    } else if (score > 40 && score <= 50) {
        left = score - 0.6;
        bottom = 9.2 + score * 0.3258;
    } else if (score > 50 && score < 60) {
        left = score - 0.6;
        bottom = 9.2 + score * 0.3258;
    } else if (score >= 60 && score <= 70) {
        left = score - 0.7;
        bottom = 9.2 + score * 0.3258;
    } else if (score > 70 && score <= 80) {
        left = score - 0.7;
        bottom = 9 + score * 0.3258;
    } else if (score > 80 && score <= 90) {
        left = score - 0.8;
        bottom = 9 + score * 0.3258;
    } else if (score > 90 && score <= 95) {
        left = score - 0.9;
        bottom = 8.8 + score * 0.3258;
    } else if (score > 95) {
        left = score - 0.1;
        bottom = 8.5 + score * 0.3258;
    }

    return [left, bottom];
}

export function ReportLeftBottomXs(score: number, type: string) {
    let left = 0;
    let bottom = 0;

    if (score <= 20) {
        left = score - 0.5;
        bottom = 25 + score * 0.3258;
    } else if (score > 20 && score < 30) {
        left = score - 0.5;
        bottom = 23 + score * 0.3258;
    } else if (score >= 30 && score <= 40) {
        left = score - 0.7;
        bottom = 21 + score * 0.3258;
    } else if (score > 40 && score <= 50) {
        left = score - 0.9;
        bottom = 19 + score * 0.3258;
    } else if (score > 50 && score < 60) {
        left = score - 0.9;
        bottom = 18 + score * 0.3258;
    } else if (score >= 60 && score <= 70) {
        left = score - 1;
        bottom = 18 + score * 0.3258;
    } else if (score > 70 && score <= 80) {
        left = score - 1.1;
        bottom = 16 + score * 0.3258;
    } else if (score > 80 && score <= 90) {
        left = score - 1.1;
        bottom = 16 + score * 0.3258;
    } else if (score > 90 && score <= 95) {
        left = score - 1;
        bottom = 14 + score * 0.3258;
    } else if (score > 95) {
        left = score - 0.2;
        bottom = 13 + score * 0.3258;
    }

    return [left, bottom];
}

export function ReportSegmentsImage(score: number, type: string) {
    let segmentsImage = "";

    if (type === "school") {
        if (score >= 0 && score <= 10) {
            segmentsImage = "/images/reports/chart-bg-insuficient.png";
        } else if (score > 10 && score <= 30) {
            segmentsImage = "/images/reports/chart-bg-satisfacator.png";
        } else if (score > 30 && score <= 60) {
            segmentsImage = "/images/reports/chart-bg-intermediar.png";
        } else if (score > 60 && score <= 80) {
            segmentsImage = "/images/reports/chart-bg-competent.png";
        } else if (score > 80 && score <= 95) {
            segmentsImage = "/images/reports/chart-bg-avansat.png";
        } else if (score > 95 && score <= 100) {
            segmentsImage = "/images/reports/chart-bg-expert.png";
        }
    } else if (type === "digitalLiteracy") {
        if (score >= 0 && score < 35) segmentsImage = "/images/reports/ld/chart-bg-nivel-baza.png";
        else if (score >= 35 && score < 65)
            segmentsImage = "/images/reports/ld/chart-bg-intermediar.png";
        else if (score >= 65 && score < 95) segmentsImage = "/images/reports/ld/chart-bg-avansat.png";
        else if (score >= 95 && score <= 100)
            segmentsImage = "/images/reports/chart-bg-specializat.png";
    } else if (type === "numericLiteracy") {
        if (score >= 0 && score < 41) segmentsImage = "/images/reports/chart-bg-nivel-baza-numeratie.png";
        else if (score >= 41 && score < 71)
            segmentsImage = "/images/reports/chart-bg-nivel-avansat-numeratie.png";
        else if (score >= 71 && score <= 100) segmentsImage = "/images/reports/chart-bg-nivel-expert-numeratie.png";
    }

    return segmentsImage;
}

export function markedLevel(score: number, level: string, type: string) {
    let marked = "";
    if (type === "school") {
        if (score <= 10 && level === "Insuficient") marked = "marked";
        else if (score > 10 && score < 30 && level === "Satisfăcător") marked = "marked";
        else if (score >= 30 && score <= 60 && level === "Intermediar") marked = "marked";
        else if (score > 60 && score <= 80 && level === "Competent") marked = "marked";
        else if (score > 80 && score < 95 && level === "Avansat") marked = "marked";
        else if (score > 95 && level === "Expert") marked = "marked";
    } else if (type === "literacy") {
        if (score >= 0 && score <= 25 && level === "Alfabetizare subdezvoltată") marked = "marked";
        else if (score > 25 && score <= 80 && level === "Nivel funcțional al alfabetizării") marked = "marked";
        else if (score > 80 && score <= 100 && level === "Nivel înalt al alfabetizării") marked = "marked";
    } else if (type === "digitalLiteracy") {
        if (score >= 0 && score < 35 && level === "Nivel de bază") marked = "marked";
        else if (score >= 35 && score < 65 && level === "Intermediar") marked = "marked";
        else if (score >= 65 && score <= 95 && level === "Avansat") marked = "marked";
        else if (score >= 95 && score <= 100 && level === "Specializat") marked = "marked";
    } else if (type === "numericLiteracy") {
        if (score >= 0 && score < 41 && level === "Nivel de bază") marked = "marked";
        else if (score >= 41 && score < 71 && level === "Nivel avansat") marked = "marked";
        else if (score >= 71 && score <= 100 && level === "Nivel expert") marked = "marked";
    }

    return marked;
}

export function markedLevelBorder(score: number, level: string, type: string) {
    let border = "";
    let color = "#fff";

    if (type === "school") {
        if (score <= 10 && level === "Insuficient") border = "2pt solid #C80000";
        else if (score > 10 && score < 30 && (level.toLowerCase() === "satisfăcător" || level.toLowerCase() === "satisfacator")) border = "2pt solid #FF5A00";
        else if (score >= 30 && score <= 60 && level === "Intermediar") border = "2pt solid #FFA500";
        else if (score > 60 && score <= 80 && level === "Competent") border = "2pt solid #82E164";
        else if (score > 80 && score < 95 && level === "Avansat") border = "2pt solid #41C828";
        else if (score > 95 && level === "Expert") border = "2pt solid #00952C";

        if (level.toLowerCase() === "insuficient") color = "#C80000";
        else if (level.toLowerCase() === "satisfăcător" || level.toLowerCase() === "satisfacator") color = "#FF5A00";
        else if (level.toLowerCase() === "intermediar") color = "#FFA500";
        else if (level.toLowerCase() === "competent") color = "#82E164";
        else if (level.toLowerCase() === "avansat") color = "#41C828";
        else if (level.toLowerCase() === "expert") color = "#00952C";

    } else if (type === "literacy") {
        if (score >= 0 && score <= 25 && level === "Alfabetizare subdezvoltată") border = "2pt solid #C80000";
        else if (score > 25 && score <= 80 && level === "Nivel funcțional al alfabetizării") border = "2pt solid #f9db00";
        else if (score > 80 && score <= 100 && level === "Nivel înalt al alfabetizării") border = "2pt solid #00952C";

        if (level === "Alfabetizare subdezvoltată") color = "#C80000";
        else if (level === "Nivel funcțional al alfabetizării") color = "#f9db00";
        else if (level === "Nivel înalt al alfabetizării") color = "#00952C";

    } else if (type === "digitalLiteracy") {
        if (score >= 0 && score < 35 && level.toLowerCase() === "nivel de bază") border = "2pt solid #fc8900";
        else if (score >= 35 && score < 65 && level.toLowerCase() === "intermediar") border = "2pt solid #f9db00";
        else if (score >= 65 && score <= 95 && level.toLowerCase() === "avansat") border = "2pt solid #07ff00";
        else if (score >= 95 && score <= 100 && level.toLowerCase() === "specializat") border = "2pt solid #0000ff";

        if (level.toLowerCase() === "nivel de bază") color = "#fc8900";
        else if (level.toLowerCase() === "intermediar") color = "#f9db00";
        else if (level.toLowerCase() === "avansat") color = "#07ff00";
        else if (level.toLowerCase() === "specializat") color = "#0000ff";

    } else if (type === "numericLiteracy") {
        if (score >= 0 && score < 41 && level === "Nivel de bază") border = "2pt solid #fc8900";
        else if (score >= 41 && score < 71 && level === "Nivel avansat") border = "2pt solid #f9db00";
        else if (score >= 71 && score <= 100 && level === "Nivel expert") border = "2pt solid #07ff00";

        if (level === "Nivel de bază") color = "#fc8900";
        else if (level === "Nivel avansat") color = "#f9db00";
        else if (level === "Nivel expert") color = "#07ff00";
    }
    return [border, color];
}

export function scoreGrades(level: string, type: string) {
    let scoreGrades = "";
    if (type === "school") {
        if (level === "Insuficient") scoreGrades = "SCOR 0–10:";
        else if (level === "Satisfăcător") scoreGrades = "SCOR 10–30:";
        else if (level === "Intermediar") scoreGrades = "SCOR 30–60:";
        else if (level === "Competent") scoreGrades = "SCOR 60–80:";
        else if (level === "Avansat") scoreGrades = "SCOR 80–95:";
        else if (level === "Expert") scoreGrades = "SCOR 95–100:";
    } else if (type === "digitalLiteracy") {
        if (level === "Nivel de bază") scoreGrades = "SCOR 0 – 35:";
        if (level === "Intermediar") scoreGrades = "SCOR 35 – 65:";
        else if (level === "Avansat") scoreGrades = "SCOR 65 – 95:";
        else if (level === "Specializat") scoreGrades = "SCOR 95 – 100:";
    } else if (type === "numericLiteracy") {
        if (level === "De bază") scoreGrades = "SCOR 0 – 40:";
        else if (level === "Avansat") scoreGrades = "SCOR 41 – 70:";
        else if (level === "Expert") scoreGrades = "SCOR 71 – 100:";
    }
    return scoreGrades;
}

export function scoreLevelName(score: number) {
    let scoreLevelName = "";
    if (score >= 0 && score <= 25) scoreLevelName = "insuficient";
    else if (score > 25 && score <= 80) scoreLevelName = "competent-literatie";
    else if (score > 80 && score <= 100) scoreLevelName = "expert";

    return scoreLevelName;
}

export function scoreLevelCssClass(level: string, type: string) {
    let scoreLevelCssClass = "";

    if (type === "literacy") {
        if (level === "Alfabetizare subdezvoltată") scoreLevelCssClass = "insuficient";
        else if (level === "Nivel funcțional al alfabetizării") scoreLevelCssClass = "competent-literatie";
        else if (level === "Nivel înalt al alfabetizării") scoreLevelCssClass = "expert";
    } else if (type === "digitalLiteracy") {
        if (level === "Nivel de bază") scoreLevelCssClass = "ld-nivel-baza";
        if (level === "Intermediar") scoreLevelCssClass = "ld-intermediar";
        else if (level === "Avansat") scoreLevelCssClass = "ld-avansat";
        else if (level === "Specializat") scoreLevelCssClass = "ld-specializat";
    } else if (type === "numericLiteracy") {
        if (level === "Nivel de bază") scoreLevelCssClass = "nd-nivel-baza";
        if (level === "Nivel avansat") scoreLevelCssClass = "nd-avansat";
        else if (level === "Nivel expert") scoreLevelCssClass = "nd-expert";
    }

    return scoreLevelCssClass;
}

export function getNumericLiteracyGradeLevels(score: number, grade: string) {

    if (grade === "I" || grade === "II" || grade === "III" || grade === "IV") {
        return [
            {
                gradeLevel: "Nivel expert",
                description: `
                <div>
                    <p>Elevul demonstrează o înțelegere profundă a conceptelor și relațiilor din cele cinci arii
                    de conținut și integrează cunoștințe și proceduri pentru a rezolva probleme complexe.
                    Mai specific, elevul:</p>
                    <ul>
                        <li>Integrează cunoștințele despre proprietățile numerelor și ale operațiilor pentru a
                        rezolva calcule lungi și probleme cu numere și operații care presupun succesiuni de
                        pași. Îi este confortabil să lucreze cu numere naturale și operații aritmetice în
                        orice context, are o înțelegere intuitivă a acestora.
                        </li>
                        <li>Alege cele mai potrivite instrumente și unități de măsură într-un context dat și își
                        poate argumenta răspunsul, interpretează răspunsurile în contextul situațiilor din
                        viața de zi cu zi (ex. poate traduce informațiile matematice în termeni de limbaj
                        natural).
                        </li>
                        <li>Demonstrează înțelegerea enunțurilor matematice legate de forme și figuri
                        geometrice, alege metode eficiente de a rezolva probleme de geometrie și își poate
                        argumenta răspunsurile.
                        </li>
                        <li>Înțelege utilitatea reprezentării grafice a datelor și alege cele mai potrivite
                        soluții de reprezentare într-un context dat, interpretează rezultatele pe care le
                        obține pentru a rezolva probleme cu date din viața de zi cu zi.
                        </li>
                        <li>Demonstrează o înțelegere de bază a conceptului de variabilă în contextul rezolvării
                        și interpretării unor probleme cu numere necunoscute sau tipare. Cunoaște
                        informațiile care îi sunt necesare pentru a începe învățarea noțiunilor de bază de
                        algebră.
                        </li>
                    </ul>
                </div>
            `,
                border: markedLevelBorder(score, "Nivel expert", "numericLiteracy")[0],
                color: markedLevelBorder(score, "Nivel expert", "numericLiteracy")[1],
                scoreTitle: "SCOR 71-100:",
                isMarked: markedLevel(score, "Nivel expert", "numericLiteracy"),
                cssClass: scoreLevelCssClass("Nivel expert", "numericLiteracy"),
            },
            {
                gradeLevel: "Nivel avansat",
                description: `
                <div>
                     <p>Elevul demonstrează o bună înțelegere a conceptelor și relațiilor din cele cinci arii de
                     conținut și reușește să aplice cunoștințe și proceduri în mod consistent pentru a
                     rezolva probleme. Mai specific, elevul:</p>
                     <ul>
                          <li>Aplică corect reguli de calcul, respectând proprietățile operațiilor aritmetice,
                          face estimări, rezolvă probleme care au în centru proprietățile numerelor naturale.
                          </li>
                          <li>Aplică formule pentru a calcula caracteristicile unor obiecte (ex. lungimea
                          laturii).
                          </li>
                          <li>Aplică cunoștințe legate de figuri și forme geometrice pentru a rezolva sarcini
                          simple, folosește termenii potriviți pentru a descrie un obiect real (masă, scaun)
                          sau teoretic (pătrat, cerc) în baza mai multor caracteristici.
                          </li>
                          <li>Rezolvă probleme simple în care informațiile necesare rezolvării exercițiului sunt
                          prezentate sub formă de tabel sau grafic.
                          </li>
                          <li>Identifică tipare și reguli (ex. în șiruri de numere) și le folosește pentru a
                          rezolva exerciții, are o înțelegere de bază a conceptului de necunoscută.
                          </li>
                     </ul>
                </div>
            `,
                border: markedLevelBorder(score, "Nivel avansat", "numericLiteracy")[0],
                color: markedLevelBorder(score, "Nivel avansat", "numericLiteracy")[1],
                scoreTitle: "SCOR 41-70:",
                isMarked: markedLevel(score, "Nivel avansat", "numericLiteracy"),
                cssClass: scoreLevelCssClass("Nivel avansat", "numericLiteracy"),
            },
            {
                gradeLevel: "Nivel de bază",
                description: `
                <div>
                     <p>Elevul demonstrează o înțelegere de bază a conceptelor și procedurilor din cele cinci
                            arii de conținut. Mai specific, elevul:</p>
                          <ul>
                               <li>Citește și ordonează numere, rezolvă operații aritmetice simple.</li>
                               <li>Identifică instrumente potrivite de măsură dintr-o listă, calculează perimetrul dacă
                                primește formula și dimensiunile laturilor.
                               </li>
                               <li>Identifică elementele figurilor geometrice (ex. numărul de laturi) dintr-o imagine
                                dată, alege corect denumirea figurilor geometrice cunoscute, descrie în limbaj
                                natural caracteristicile de bază ale unui obiect real (masă, scaun) sau teoretic
                                (pătrat, cerc).
                               </li>
                               <li>Găsește informațiile necesare într-un tabel sau o reprezentare grafică simplă.</li>
                               <li>Completează un șir de numere sau obiecte dacă i se spune care este regula (sau
                                ghicește regula dacă este foarte simplă sau familiară), află numărul necunoscut
                                într-un calcul foarte simplu.
                               </li>
                          </ul>
                          <ul>
                               <li>Citește și ordonează numere, rezolvă operații aritmetice simple.</li>
                               <li>Identifică instrumente potrivite de măsură dintr-o listă, calculează perimetrul dacă
                                primește formula și dimensiunile laturilor.
                               </li>
                               <li>Identifică elementele figurilor geometrice (ex. numărul de laturi) dintr-o imagine
                                dată, alege corect denumirea figurilor geometrice cunoscute, descrie în limbaj
                                natural caracteristicile de bază ale unui obiect real (masă, scaun) sau teoretic
                                (pătrat, cerc).
                               </li>
                               <li>Găsește informațiile necesare într-un tabel sau o reprezentare grafică simplă.</li>
                               <li>Completează un șir de numere sau obiecte dacă i se spune care este regula (sau
                                ghicește regula dacă este foarte simplă sau familiară), află numărul necunoscut
                                într-un calcul foarte simplu.
                               </li>
                        </ul>
                </div>
            `,
                border: markedLevelBorder(score, "Nivel de bază", "numericLiteracy")[0],
                color: markedLevelBorder(score, "Nivel de bază", "numericLiteracy")[1],
                scoreTitle: "SCOR 0-40:",
                isMarked: markedLevel(score, "Nivel de bază", "numericLiteracy"),
                cssClass: scoreLevelCssClass("Nivel de bază", "numericLiteracy"),
            },
        ]
    } else if(grade === "V" || grade === "VI" || grade === "VII" || grade === "VIII") {
        return [
            {
                gradeLevel: "Nivel expert",
                description: `
                <div>
                    <p>Elevul demonstrează o înțelegere profundă a conceptelor și relațiilor din cele cinci arii
                    de conținut. Poate integra aceste cunoștințe pentru a rezolva probleme complexe și
                    nefamiliare, oferind justificări pentru deciziile pe care le ia și pentru soluțiile la
                    care ajunge și reflectând asupra strategiilor pe care le folosește. Mai specific,
                    elevul:</p>
                    <ul>
                        <li>Cunoaște, aplică și integrează cunoștințele despre numere și operații cu numere,
                            interpretează informațiile pe care le are la dispoziție pentru a ajunge la o soluție
                            corectă sau pentru a lua decizii legate de strategia de rezolvare a problemei și își
                            argumentează alegerea, rezolvă probleme complexe și îi este natural să lucreze cu
                            numere de toate felurile (inclusiv numere iraționale și complexe) în orice context.
                        </li>
                        <li>Alege cele mai potrivite strategii pentru a calcula atribute fizice sau a rezolva
                            probleme legate de elementele formelor și figurilor geometrice și poate testa
                            aserțiuni sau argumenta soluțiile la care ajunge și deciziile pe care le ia în
                            rezolvarea problemelor. Are cunoștințe solide de trigonometrie pe care le poate
                            aplica în probleme complexe.
                        </li>
                        <li>Integrează cunoștințele de geometrie pentru a rezolva probleme complexe,
                            demonstrează teoreme, validează și argumentează răspunsurile sale legate de
                            caracteristicile obiectelor și figurilor geometrice sau relațiile dintre acestea.
                        </li>
                        <li>Compară distribuții de date în funcție de caracteristicile acestora (inclusiv
                            indicatorii tendinței centrale, dacă primește formulele) și își argumentează
                            răspunsurile, alege cele mai bune metode de a rezolva probleme cu date reprezentate
                            grafic sau în tabele, testează ipoteze și interpretează informațiile în funcție de
                            contextul problemei. Demonstrează înțelegerea conceptelor de experiment și eșantion
                            și poate analiza critic concluzii pe baza unui set de date.
                        </li>
                        <li>Aplică cunoștințele de algebră și alege cele mai potrivite strategii pentru a
                            rezolva exerciții și probleme, inclusiv ecuații, inecuații și funcții, chiar și în
                            situații în care este nevoie de calcule repetate sau operarea cu numere reale foarte
                            mari sau foarte mici, respectiv numere iraționale sau complexe. Își argumentează
                            răspunsurile și testează aserțiuni, demonstrând o înțelegere profundă a conceptului
                            de variabilă în matematică.
                        </li>
                    </ul>
                </div>
            `,
                border: markedLevelBorder(score, "Nivel expert", "numericLiteracy")[0],
                color: markedLevelBorder(score, "Nivel expert", "numericLiteracy")[1],
                scoreTitle: "SCOR 71-100:",
                isMarked: markedLevel(score, "Nivel expert", "numericLiteracy"),
                cssClass: scoreLevelCssClass("Nivel expert", "numericLiteracy"),
            },
            {
                gradeLevel: "Nivel avansat",
                description: `
                <div>
                     <p>Elevul recunoaște situațiile în care anumite concepte, strategii și proceduri sunt utile
                     sau potrivite și le poate alege, integra și aplica pentru a rezolva probleme. Poate
                     testa și valida asumpții folosind o varietate de metode. Mai specific, elevul:</p>
                     <ul>
                         <li>Aplică cunoștințele despre proprietățile și relațiile dintre numere și operații
                            pentru a rezolva exerciții și probleme cu numere reale și se descurcă în sarcinile
                            care includ numere iraționale sau complexe care presupun un număr redus de pași sau
                            calcule.
                         </li>
                         <li>Cunoaște și aplică reguli de calcul pentru diferite elemente ale formelor și
                            corpurilor geometrice, rezolvă probleme din viața de zi cu zi în care sunt implicate
                            aspecte de trigonometrie și are o bună înțelegere a utilizării sistemelor de
                            măsurare în contexte diverse.
                         </li>
                         <li>Rezolvă probleme pornind de la cunoștințele de geometrie dobândite, legate de
                            caracteristicile figurilor și corpurilor și a relațiilor dintre forme și elementele
                            formelor. Testează aserțiuni bine definite și face demonstrații pentru teoreme
                            cunoscute pentru a atinge un scop, chiar dacă nu i se cere explicit să folosească o
                            teoremă sau o formulă anume.
                         /li>
                         <li>Compară distribuții de date în funcție de caracteristicile acestora (inclusiv
                            indicatorii tendinței centrale, dacă primește formulele) și rezolvă probleme
                            complexe pornind de la date aranjate în tabele și grafice.
                         </li>
                         <li>Aplică cunoștințele de algebră pentru a rezolva exerciții și probleme, inclusiv
                            ecuații, inecuații și funcții, chiar și în situații în care este nevoie de calcule
                            repetate sau operarea cu numere foarte mari sau foarte mici. Stăpânește bine
                            conceptul de variabilă matematică și îl poate folosi în situații din viața de zi cu
                            zi, pentru a lucra cu valori schimbătoare sau necunoscute.
                         </li>
                     </ul>
                </div>
            `,
                border: markedLevelBorder(score, "Nivel avansat", "numericLiteracy")[0],
                color: markedLevelBorder(score, "Nivel avansat", "numericLiteracy")[1],
                scoreTitle: "SCOR 41-70:",
                isMarked: markedLevel(score, "Nivel avansat", "numericLiteracy"),
                cssClass: scoreLevelCssClass("Nivel avansat", "numericLiteracy"),
            },
            {
                gradeLevel: "Nivel de bază",
                description: `
                <div>
                     <p>Elevul demonstrează o înțelegere de bază a conceptelor și procedurilor din cele cinci
                        arii de conținut și poate rezolva probleme care necesită aplicarea directă a
                        cunoștințelor de alfabetizare matematică în situații din viața reală. Mai specific,
                        elevul:</p>
                        <ul>
                            <li>Identifică proprietățile numerelor și operațiilor în situații simple, exprimate în
                                limbaj natural sau matematic. Rezolvă probleme cu numere reale care presupun
                                aplicarea directă a unor cunoștințe de bază deja asimilate sau oferite în cadrul
                                exercițiului.
                            </li>
                            <li>Rezolvă probleme simple în care trebuie să identifice unitatea de măsură pentru o
                                situație dată sau să calculeze caracteristicile obiectelor pe baza unor formule
                                foarte cunoscute sau furnizate în cadrul exercițiului.
                            </li>
                            <li>Indică denumirea, caracteristicile sau relațiile (ex. mai mic, mai mare) dintre
                                figuri și corpuri geometrice în cadrul unor probleme cu un grad scăzut de
                                complexitate.
                            </li>
                            <li>Găsește datele necesare rezolvării unei probleme în interiorul unui tabel sau a unui
                                grafic și calculează indicatori ai tendinței centrale (dacă are acces la formulă) și
                                probabilități (pe baza cunoașterii anterioare a formulei) pornind de la date
                                reprezentate în tabele.
                            </li>
                            <li>Cunoaște formule și reguli de bază din algebră (ex. formule de calcul prescurtat) și
                                le poate aplica direct pentru a rezolva probleme clar definite.
                            </li>
                        </ul>
                </div>
            `,
                border: markedLevelBorder(score, "Nivel de bază", "numericLiteracy")[0],
                color: markedLevelBorder(score, "Nivel de bază", "numericLiteracy")[1],
                scoreTitle: "SCOR 0-40:",
                isMarked: markedLevel(score, "Nivel de bază", "numericLiteracy"),
                cssClass: scoreLevelCssClass("Nivel de bază", "numericLiteracy"),
            },
        ]
    } else {
        return [
            {
                gradeLevel: "Nivel expert",
                description: `
                <div>
                    <p>Elevul demonstrează o înțelegere profundă a conceptelor și relațiilor din cele cinci arii
                                de conținut. Poate integra aceste cunoștințe pentru a rezolva probleme complexe și
                                nefamiliare, oferind justificări pentru deciziile pe care le ia și pentru soluțiile la
                                care ajunge și reflectând asupra strategiilor pe care le folosește. Mai specific,
                                elevul:</p>
                            <ul>
                                <li>Cunoaște, aplică și integrează cunoștințele despre numere și operații cu numere,
                                    interpretează informațiile pe care le are la dispoziție pentru a ajunge la o soluție
                                    corectă sau pentru a lua decizii legate de strategia de rezolvare a problemei și își
                                    argumentează alegerea, rezolvă probleme complexe și îi este natural să lucreze cu
                                    numere de toate felurile (inclusiv numere iraționale și complexe) în orice context.
                                </li>
                                <li>Alege cele mai potrivite strategii pentru a calcula atribute fizice sau a rezolva
                                    probleme legate de elementele formelor și figurilor geometrice și poate testa
                                    aserțiuni sau argumenta soluțiile la care ajunge și deciziile pe care le ia în
                                    rezolvarea problemelor. Are cunoștințe solide de trigonometrie pe care le poate
                                    aplica în probleme complexe.
                                </li>
                                <li>Integrează cunoștințele de geometrie pentru a rezolva probleme complexe,
                                    demonstrează teoreme, validează și argumentează răspunsurile sale legate de
                                    caracteristicile obiectelor și figurilor geometrice sau relațiile dintre acestea.
                                </li>
                                <li>Compară distribuții de date în funcție de caracteristicile acestora (inclusiv
                                    indicatorii tendinței centrale, dacă primește formulele) și își argumentează
                                    răspunsurile, alege cele mai bune metode de a rezolva probleme cu date reprezentate
                                    grafic sau în tabele, testează ipoteze și interpretează informațiile în funcție de
                                    contextul problemei. Demonstrează înțelegerea conceptelor de experiment și eșantion
                                    și poate analiza critic concluzii pe baza unui set de date.
                                </li>
                                <li>Aplică cunoștințele de algebră și alege cele mai potrivite strategii pentru a
                                    rezolva exerciții și probleme, inclusiv ecuații, inecuații și funcții, chiar și în
                                    situații în care este nevoie de calcule repetate sau operarea cu numere reale foarte
                                    mari sau foarte mici, respectiv numere iraționale sau complexe. Își argumentează
                                    răspunsurile și testează aserțiuni, demonstrând o înțelegere profundă a conceptului
                                    de variabilă în matematică.
                                </li>
                            </ul>
                </div>
            `,
                border: markedLevelBorder(score, "Nivel expert", "numericLiteracy")[0],
                color: markedLevelBorder(score, "Nivel expert", "numericLiteracy")[1],
                scoreTitle: "SCOR 71-100:",
                isMarked: markedLevel(score, "Nivel expert", "numericLiteracy"),
                cssClass: scoreLevelCssClass("Nivel expert", "numericLiteracy"),
            },
            {
                gradeLevel: "Nivel avansat",
                description: `
                <div>
                     <p>Elevul recunoaște situațiile în care anumite concepte, strategii și proceduri sunt utile
                                sau potrivite și le poate alege, integra și aplica pentru a rezolva probleme. Poate
                                testa și valida asumpții folosind o varietate de metode. Mai specific, elevul:</p>
                            <ul>
                                <li>Aplică cunoștințele despre proprietățile și relațiile dintre numere și operații
                                    pentru a rezolva exerciții și probleme cu numere reale și se descurcă în sarcinile
                                    care includ numere iraționale sau complexe care presupun un număr redus de pași sau
                                    calcule.
                                </li>
                                <li>Cunoaște și aplică reguli de calcul pentru diferite elemente ale formelor și
                                    corpurilor geometrice, rezolvă probleme din viața de zi cu zi în care sunt implicate
                                    aspecte de trigonometrie și are o bună înțelegere a utilizării sistemelor de
                                    măsurare în contexte diverse.
                                </li>
                                <li>Rezolvă probleme pornind de la cunoștințele de geometrie dobândite, legate de
                                    caracteristicile figurilor și corpurilor și a relațiilor dintre forme și elementele
                                    formelor. Testează aserțiuni bine definite și face demonstrații pentru teoreme
                                    cunoscute pentru a atinge un scop, chiar dacă nu i se cere explicit să folosească o
                                    teoremă sau o formulă anume.
                                </li>
                                <li>Compară distribuții de date în funcție de caracteristicile acestora (inclusiv
                                    indicatorii tendinței centrale, dacă primește formulele) și rezolvă probleme
                                    complexe pornind de la date aranjate în tabele și grafice.
                                </li>
                                <li>Aplică cunoștințele de algebră pentru a rezolva exerciții și probleme, inclusiv
                                    ecuații, inecuații și funcții, chiar și în situații în care este nevoie de calcule
                                    repetate sau operarea cu numere foarte mari sau foarte mici. Stăpânește bine
                                    conceptul de variabilă matematică și îl poate folosi în situații din viața de zi cu
                                    zi, pentru a lucra cu valori schimbătoare sau necunoscute.
                                </li>
                            </ul>
                </div>
            `,
                border: markedLevelBorder(score, "Nivel avansat", "numericLiteracy")[0],
                color: markedLevelBorder(score, "Nivel avansat", "numericLiteracy")[1],
                scoreTitle: "SCOR 41-70:",
                isMarked: markedLevel(score, "Nivel avansat", "numericLiteracy"),
                cssClass: scoreLevelCssClass("Nivel avansat", "numericLiteracy"),
            },
            {
                gradeLevel: "Nivel de bază",
                description: `
                <div>
                     <p>Elevul demonstrează o înțelegere de bază a conceptelor și procedurilor din cele cinci
                                arii de conținut și poate rezolva probleme care necesită aplicarea directă a
                                cunoștințelor de alfabetizare matematică în situații din viața reală. Mai specific,
                                elevul:</p>
                            <ul>
                                <li>Identifică proprietățile numerelor și operațiilor în situații simple, exprimate în
                                    limbaj natural sau matematic. Rezolvă probleme cu numere reale care presupun
                                    aplicarea directă a unor cunoștințe de bază deja asimilate sau oferite în cadrul
                                    exercițiului.
                                </li>
                                <li>Rezolvă probleme simple în care trebuie să identifice unitatea de măsură pentru o
                                    situație dată sau să calculeze caracteristicile obiectelor pe baza unor formule
                                    foarte cunoscute sau furnizate în cadrul exercițiului.
                                </li>
                                <li>Indică denumirea, caracteristicile sau relațiile (ex. mai mic, mai mare) dintre
                                    figuri și corpuri geometrice în cadrul unor probleme cu un grad scăzut de
                                    complexitate.
                                </li>
                                <li>Găsește datele necesare rezolvării unei probleme în interiorul unui tabel sau a unui
                                    grafic și calculează indicatori ai tendinței centrale (dacă are acces la formulă) și
                                    probabilități (pe baza cunoașterii anterioare a formulei) pornind de la date
                                    reprezentate în tabele.
                                </li>
                                <li>Cunoaște formule și reguli de bază din algebră (ex. formule de calcul prescurtat) și
                                    le poate aplica direct pentru a rezolva probleme clar definite.
                                </li>
                            </ul>
                </div>
            `,
                border: markedLevelBorder(score, "Nivel de bază", "numericLiteracy")[0],
                color: markedLevelBorder(score, "Nivel de bază", "numericLiteracy")[1],
                scoreTitle: "SCOR 0-40:",
                isMarked: markedLevel(score, "Nivel de bază", "numericLiteracy"),
                cssClass: scoreLevelCssClass("Nivel de bază", "numericLiteracy"),
            },
        ]
    }
}

export const getNumericLiteracyCategoryName = (index: number) => {
    if(index === 0) return "Proprietăți ale numerelor și Operații cu numerele";
    if(index === 1) return "Măsurare";
    if(index === 2) return "Geometrie";
    if(index === 3) return "Analiza datelor, Statistică și Probabilități";
    if(index === 4) return "Algebră";
}

export const getNumericLiteracySubcategories = (grade: any) => {
    const primar = ["I", "II", "III", "IV"];
    const gimnaziu = ["V", "VI", "VII", "VIII"];
    const liceu = ["IX", "X", "XI", "XII"];

    if(primar.includes(grade)) return [
        `<h4>Simțul numerelor </h4>
<p>Simțul numerelor se referă la o înțelegere intuitivă a numerelor de toate felurile (numere naturale, dar și numere
    negative, fracții, radicali, etc.) și a relațiilor dintre acestea. Implică capacitatea de a manipula mental numerele
    și de a înțelege semnificația lor în diverse contexte, de a intui valoarea numerică, de a identifica forme
    echivalente ale unor numere și de a folosi numere pentru a reprezenta atribute ale obiectelor și cantităților
    întâlnite în viața de zi cu zi.</p>
<h4>Estimare</h4>
<p>Estimarea este procesul de a face o presupunere sau o aproximare rezonabilă unei cantități sau valori. Ea se poate
    realiza prin diverse metode, cum ar fi rotunjirea, utilizarea unor referințe (ex. compararea unei fracții cu o
    valoare cunoscută cum ar fi sfertul, jumătatea sau întregul) sau simplificarea pentru a ajunge la un răspuns
    apropiat de cel căutat, chiar dacă nu este neapărat exact. Implică, de asemenea, capacitatea de a identifica
    situațiile oportune în care estimarea este potrivită și poate fi utilă.</p>
<h4>Operații cu numere</h4>
<p>Această categorie se referă la capacitatea de a efectua operații matematice cu numere, cum ar fi adunare, scădere,
    înmulțire și împărțire, în orice situație aplicată din viața reală. Include abilități de manipulare și calcul cu
    numere, aplicarea corectă a regulilor de calcul și verificarea rezultatelor.</p>
<h4>Rapoarte și raționament proporțional</h4>
<p>Această categorie se concentrează pe înțelegerea și aplicarea corectă a cunoștințelor despre rapoarte și proporții.
    Implică abilitatea de a identifica situațiile în care proprietățile rapoartelor pot fi aplicate, cum ar fi regula de
    trei simplă.</p>
<h4>Proprietăți ale numerelor și ale operațiilor </h4>
<p>Această categorie implică înțelegerea proprietăților numerelor de orice fel (naturale, fracții, radicali, etc.) și
    ale operațiilor aritmetice. Include cunoașterea unor proprietăți ale numerelor cum ar fi paritatea sau criteriile de
    divizibilitate, proprietăți ale operațiilor aritmetice și reguli legate de ordinea efectuării acestora. Presupune,
    de asemenea, capacitatea de a aplica aceste cunoștințe în situații aplicate și de a ține cont de ele chiar și atunci
    când nu i se cere în mod explicit să o facă.</p>
<h4>Raționament matematic folosind numerele </h4>
<p>Această categorie se referă la abilitatea elevilor de a aplica gândirea
    matematică în diverse contexte, cu focus pe tematica acestei componente largi: numere și operații cu numere. Implică
    capacitatea de a argumenta, justifica sau testa validitatea unor proprietăți și relații în lucrul cu numerele și
    operațiile aritmetice.</p>`,
        `<h4>Calculul atributelor fizice</h4>
<p>Această categorie se referă la abilitatea de a estima, măsura și compara diferite proprietăți fizice ale obiectelor
    reale (masă, minge, etc.) sau teoretice (sferă, tetraedru, etc.), cum ar fi lungimea, masa, sau volumul. Include 
    înțelegerea și cunoașterea termenilor care descriu dimensiunea, cum ar fi aria sau perimetrul, respectiv aplicarea 
    cunoștințelor despre măsurare în contexte practice.</p>
<h4>Sisteme de măsurare </h4>
<p>Această categorie se referă la înțelegerea și utilizarea diferitelor sisteme de măsurare, cum ar fi sistemul metric. 
    Include cunoașterea unităților de măsură potrivite pentru atribute specifice, capacitatea de a converti între unități 
    de măsură și de a utiliza instrumente de măsurare adecvate.</p>`,
`<h4>Dimensiune și formă </h4>
<p>Această categorie se referă la identificarea și înțelegerea dimensiunilor și formelor unor obiecte geometrice reale
    (masă, scaun, etc.) sau teoretice (sferă, tetraedru, etc). Include capacitatea de a recunoaște și de a descrie
    proprietățile obiectelor geometrice în spațiu, de a diferenția obiecte variate unele de celelalte, de a aprecia
    forma, mărimea și alte caracteristici legate de un obiect și spațiul în care acesta există.</p>
<h4>Transformarea formelor și păstrarea proprietăților</h4>
<p>Această categorie se referă la înțelegerea transformărilor formelor prin procese ca răsturnarea, desfășurarea sau
    rotirea, respectiv la cunoașterea proprietăților geometrice care rămân constante în timpul acestor transformări.
    Include cunoașterea conceptelor de simetrie, congruență și similaritate și la aplicarea acestor cunoștințe în
    rezolvarea de probleme cu corpuri și figuri geometrice.</p>
<h4>Relații între figurile geometrice </h4>
<p>Această categorie se concentrează pe înțelegerea relațiilor și asemănărilor dintre diferite figuri geometrice. Elevii
    trebuie să poată identifica, descrie și folosi cunoștințe despre relațiile dintre obiecte, figuri și corpuri
    geometrice, respectiv elemente ale acestora (laturi, unghiuri, fețe, etc), cum ar fi perpendicularitatea sau
    paralelismul.</p>
<h4>Poziția, direcția și geometria coordonatelor </h4>
<p>Această categorie implică abilitatea de a înțelege și de a utiliza concepte cum ar fi poziția (sus, jos, deasupra,
    etc.), direcția (stânga, dreapta, etc.) și geometria coordonată în spațiu. Include capacitatea de a utiliza
    coordonate pentru a localiza puncte într-un sistem de referință. Conține abilități importante pentru înțelegerea
    lumii înconjurătoare, orientare în spațiu, aprecierea distanțelor și alte activități similare.</p>
<h4>Raționamentul matematic în geometrie </h4>
<p>Această categorie se referă la aplicarea raționamentului matematic orice
    context specific geometriei. Elevii trebuie să demonstreze gândire logică și abilitatea de a rezolva probleme
    complexe în geometrie, să argumenteze validitatea unor relații între elemente ale figurilor geometrice, să treacă
    mai departe de cunoașterea și aplicarea unor informații specifice geometriei, demonstrând autonomie și o strategie
    clară de rezolvare a problemelor din contexte variate.</p>`,
        `<h4>Reprezentarea datelor </h4>
<p>Această categorie implică abilitatea de a reprezenta și interpreta date folosind diferite forme de prezentare, cum ar
    fi tabelele, diagramele și grafice. Include abilitatea de a transforma datele dintr-o formă de prezentare în alta,
    de a alege cea mai eficientă metodă de prezentare pentru un scop dat și de a rezolva probleme folosind unul sau mai
    multe seturi de date.</p>
<h4>Caracteristici ale seturilor de date</h4>
<p>Această categorie se referă la înțelegerea caracteristicilor seturilor de date, atât la nivel intuitiv (ex.
    compararea seturilor de date între ele) cât și prin cunoașterea unor noțiuni de bază de statistică, cum ar fi
    indicatorii tendinței centrale (ex. medie, mediană, mod). Implică înțelegerea atât a sensului cât și a utilității
    acestor caracteristici ale datelor.</p>
<h4>Probabilități </h4>
<p>Această categorie se referă la înțelegerea șanselor și probabilităților unor evenimente. Include capacitatea de a
    calcula probabilitatea, de a rezolva probleme care au în centru conceptul de șansă și de a demonstra o înțelegere a
    conceptului de probabilitate în sens general. Implică înțelegerea sensului unor formulări ca: posibil, probabil,
    favorabil.</p>
<h4>Raționament matematic cu date </h4>
<p>Această categorie implică utilizarea logicii și a raționamentului matematic în
    contextul interpretării datelor. Elevii trebuie să poată extrage concluzii, să facă inferențe și să rezolve probleme
    bazate pe date și informații.</p>`,
        `<h4>Modele, relații și funcții </h4>
<p>Această categorie implică identificarea, înțelegerea și prelucrarea modelelor bazate pe reguli (ex. șiruri de numere 
    formate pe baza unei reguli date), a relațiilor și a funcțiilor. Elevii trebuie să poată recunoaște și să aplice reguli 
    și tipare pentru a rezolva probleme din contexte variate. </p>
<h4>Ecuații și inecuații </h4>
<p style="margin-bottom: 50px!important">Această categorie se concentrează pe rezolvarea și interpretarea ecuațiilor și inecuațiilor. Elevii 
    trebuie să poată rezolva ecuații și inecuații, să identifice soluțiile și să rezolve probleme care au la bază conceptul 
    de valoare necunoscută.</p>`
    ]
    else if(gimnaziu.includes(grade)) return [
        `<h4>Simțul numerelor </h4>
<p>Simțul numerelor se referă la o înțelegere intuitivă a numerelor de toate felurile (numere naturale, dar și numere
    negative, fracții, radicali, etc.) și a relațiilor dintre acestea. Implică capacitatea de a manipula mental numerele
    și de a înțelege semnificația lor în diverse contexte, de a intui valoarea numerică, de a identifica forme
    echivalente ale unor numere și de a folosi numere pentru a reprezenta atribute ale obiectelor și cantităților
    întâlnite în viața de zi cu zi.</p>
<h4>Estimare</h4>
<p>Estimarea este procesul de a face o presupunere sau o aproximare rezonabilă unei cantități sau valori. Ea se poate
    realiza prin diverse metode, cum ar fi rotunjirea, utilizarea unor referințe (ex. compararea unei fracții cu o
    valoare cunoscută cum ar fi sfertul, jumătatea sau întregul) sau simplificarea pentru a ajunge la un răspuns
    apropiat de cel căutat, chiar dacă nu este neapărat exact. Implică, de asemenea, capacitatea de a identifica
    situațiile oportune în care estimarea este potrivită și poate fi utilă.</p>
<h4>Operații cu numere</h4>
<p>Această categorie se referă la capacitatea de a efectua operații matematice cu numere, cum ar fi adunare, scădere,
    înmulțire și împărțire, în orice situație aplicată din viața reală. Include abilități de manipulare și calcul cu
    numere, aplicarea corectă a regulilor de calcul și verificarea rezultatelor.</p>
<h4>Rapoarte și raționament proporțional</h4>
<p>Această categorie se concentrează pe înțelegerea și aplicarea corectă a cunoștințelor despre rapoarte și proporții.
    Implică abilitatea de a identifica situațiile în care proprietățile rapoartelor pot fi aplicate, cum ar fi regula de
    trei simplă.</p>
<h4>Proprietăți ale numerelor și ale operațiilor </h4>
<p>Această categorie implică înțelegerea proprietăților numerelor de orice fel (naturale, fracții, radicali, etc.) și
    ale operațiilor aritmetice. Include cunoașterea unor proprietăți ale numerelor cum ar fi paritatea sau criteriile de
    divizibilitate, proprietăți ale operațiilor aritmetice și reguli legate de ordinea efectuării acestora. Presupune,
    de asemenea, capacitatea de a aplica aceste cunoștințe în situații aplicate și de a ține cont de ele chiar și atunci
    când nu i se cere în mod explicit să o facă.</p>
<h4>Raționament matematic folosind numerele </h4>
<p>Această categorie se referă la abilitatea elevilor de a aplica gândirea
    matematică în diverse contexte, cu focus pe tematica acestei componente largi: numere și operații cu numere. Implică
    capacitatea de a argumenta, justifica sau testa validitatea unor proprietăți și relații în lucrul cu numerele și
    operațiile aritmetice.</p>`,
        `<h4>Calculul atributelor fizice</h4>
<p>Această categorie se referă la abilitatea de a estima, măsura și compara diferite proprietăți fizice ale obiectelor
    reale (masă, minge, etc.) sau teoretice (sferă, tetraedru, etc.), cum ar fi lungimea, masa, sau volumul. Include
    înțelegerea și cunoașterea termenilor care descriu dimensiunea, cum ar fi aria sau perimetrul, respectiv aplicarea
    cunoștințelor despre măsurare în contexte practice.</p>
<h4>Sisteme de măsurare </h4>
<p>Această categorie se referă la înțelegerea și utilizarea diferitelor sisteme de măsurare, cum ar fi sistemul metric.
    Include cunoașterea unităților de măsură potrivite pentru atribute specifice, capacitatea de a converti între
    unități de măsură și de a utiliza instrumente de măsurare adecvate.</p>
<h4>Calcule în triunghiuri </h4>
<p>Această categorie implică abilitatea de a calcula și înțelege relațiile dimensionale în triunghiuri. Elevii trebuie
    să cunoască, identifice și descrie diferite tipuri de unghiuri și triunghiuri și să cunoască și aplice cunoștințe de
    geometrie și/ sau trigonometrie în rezolvarea problemelor.</p>`,
        `<h4>Dimensiune și formă </h4>
<p>Această categorie se referă la identificarea și înțelegerea dimensiunilor și formelor unor obiecte geometrice reale
    (masă, scaun, etc.) sau teoretice (sferă, tetraedru, etc). Include capacitatea de a recunoaște și de a descrie
    proprietățile obiectelor geometrice în spațiu, de a diferenția obiecte variate unele de celelalte, de a aprecia
    forma, mărimea și alte caracteristici legate de un obiect și spațiul în care acesta există.</p>
<h4>Transformarea formelor și păstrarea proprietăților</h4>
<p>Această categorie se referă la înțelegerea transformărilor formelor prin procese ca răsturnarea, desfășurarea sau
    rotirea, respectiv la cunoașterea proprietăților geometrice care rămân constante în timpul acestor transformări.
    Include cunoașterea conceptelor de simetrie, congruență și similaritate și la aplicarea acestor cunoștințe în
    rezolvarea de probleme cu corpuri și figuri geometrice.</p>
<h4>Relații între figurile geometrice </h4>
<p>Această categorie se concentrează pe înțelegerea relațiilor și asemănărilor dintre diferite figuri geometrice. Elevii
    trebuie să poată identifica, descrie și folosi cunoștințe despre relațiile dintre obiecte, figuri și corpuri
    geometrice, respectiv elemente ale acestora (laturi, unghiuri, fețe, etc), cum ar fi perpendicularitatea sau
    paralelismul.</p>
<h4>Poziția, direcția și geometria coordonatelor </h4>
<p>Această categorie implică abilitatea de a înțelege și de a utiliza concepte cum ar fi poziția (sus, jos, deasupra,
    etc.), direcția (stânga, dreapta, etc.) și geometria coordonată în spațiu. Include capacitatea de a utiliza
    coordonate pentru a localiza puncte într-un sistem de referință. Conține abilități importante pentru înțelegerea
    lumii înconjurătoare, orientare în spațiu, aprecierea distanțelor și alte activități similare.</p>
<h4>Raționamentul matematic în geometrie </h4>
<p style="margin-bottom: 50px!important">Această categorie se referă la aplicarea raționamentului matematic orice
    context specific geometriei. Elevii trebuie să demonstreze gândire logică și abilitatea de a rezolva probleme
    complexe în geometrie, să argumenteze validitatea unor relații între elemente ale figurilor geometrice, să treacă
    mai departe de cunoașterea și aplicarea unor informații specifice geometriei, demonstrând autonomie și o strategie
    clară de rezolvare a problemelor din contexte variate.</p>`,
        `<h4>Reprezentarea datelor </h4>
<p>Această categorie implică abilitatea de a reprezenta și interpreta date folosind diferite forme de prezentare, cum ar
    fi tabelele, diagramele și grafice. Include abilitatea de a transforma datele dintr-o formă de prezentare în alta,
    de a alege cea mai eficientă metodă de prezentare pentru un scop dat și de a rezolva probleme folosind unul sau mai
    multe seturi de date.</p>
<h4>Caracteristici ale seturilor de date</h4>
<p>Această categorie se referă la înțelegerea caracteristicilor seturilor de date, atât la nivel intuitiv (ex.
    compararea seturilor de date între ele) cât și prin cunoașterea unor noțiuni de bază de statistică, cum ar fi
    indicatorii tendinței centrale (ex. medie, mediană, mod). Implică înțelegerea atât a sensului cât și a utilității
    acestor caracteristici ale datelor.</p>
<h4>Probabilități </h4>
<p>Această categorie se referă la înțelegerea șanselor și probabilităților unor evenimente. Include capacitatea de a
    calcula probabilitatea, de a rezolva probleme care au în centru conceptul de șansă și de a demonstra o înțelegere a
    conceptului de probabilitate în sens general. Implică înțelegerea sensului unor formulări ca: posibil, probabil,
    favorabil.</p>
<h4>Raționament matematic cu date </h4>
<p>Această categorie implică utilizarea logicii și a raționamentului matematic în
    contextul interpretării datelor. Elevii trebuie să poată extrage concluzii, să facă inferențe și să rezolve probleme
    bazate pe date și informații.</p>`,
        `<h4>Modele, relații și funcții </h4>
<p>Această categorie implică identificarea, înțelegerea și prelucrarea modelelor bazate pe reguli (ex. șiruri de numere
    formate pe baza unei reguli date), a relațiilor și a funcțiilor. Elevii trebuie să poată recunoaște și să aplice
    reguli și tipare pentru a rezolva probleme din contexte variate. </p>
<h4>Reprezentări algebrice </h4>
<p>Această categorie se referă la utilizarea simbolurilor și expresiilor algebrice pentru a reprezenta și a rezolva
    probleme. Include capacitatea de a traduce situații din limbajul comun în limbajul algebric și invers.</p>
<h4>Variabile, expresii și operații</h4>
<p>Această categorie implică înțelegerea conceptului de variabilă și aplicarea acestuia în algebră, reprezentarea și
    manipularea expresiilor algebrice și a operațiilor dintre acestea. Elevii trebuie să poată să identifice expresii
    algebrice care sunt echivalente, să aplice reguli ale operațiilor algebrice și să recunoască proprietățile
    expresiilor.</p>
<h4>Ecuații și inecuații </h4>
<p>Această categorie se concentrează pe rezolvarea și interpretarea ecuațiilor și inecuațiilor. Elevii trebuie să poată
    rezolva ecuații și inecuații, să identifice soluțiile și să rezolve probleme care au la bază conceptul de valoare
    necunoscută.</p>
<h4>Raționament matematic în algebră </h4>
<p>Această categorie se referă la utilizarea gândirii matematice în orice context în care lucrează cu variabile și
    concepte specifice algebrei. Raționamentul matematic presupune înțelegerea profundă, testarea și demonstrarea unor
    relații, iar această subcategorie de conținut se referă la aplicarea acestor abilități în orice situație din viața
    reală în care elevul lucrează cu date care nu sunt cunoscute și constante.</p>`
    ]
    else return [
        `<h4>Proprietăți ale numerelor și ale operațiilor </h4>
<p>Această categorie implică înțelegerea proprietăților numerelor de orice fel (naturale, fracții, radicali, etc.) și
    ale operațiilor aritmetice. Include cunoașterea unor proprietăți ale numerelor cum ar fi paritatea sau criteriile de
    divizibilitate, proprietăți ale operațiilor aritmetice și reguli legate de ordinea efectuării acestora. Presupune,
    de asemenea, capacitatea de a aplica aceste cunoștințe în situații aplicate și de a ține cont de ele chiar și atunci
    când nu i se cere în mod explicit să o facă.</p>
<h4>Raționament matematic folosind numerele </h4>
<p>Această categorie se referă la abilitatea elevilor de a aplica gândirea matematică în diverse contexte, cu focus pe
    tematica acestei componente largi: numere și operații cu numere. Implică capacitatea de a argumenta, justifica sau
    testa validitatea unor proprietăți și relații în lucrul cu numerele și operațiile aritmetice.</p>
<h4>Simțul numerelor </h4>
<p>Simțul numerelor se referă la o înțelegere intuitivă a numerelor de toate felurile (numere naturale, dar și numere
    negative, fracții, radicali, etc.) și a relațiilor dintre acestea. Implică capacitatea de a manipula mental numerele
    și de a înțelege semnificația lor în diverse contexte, de a intui valoarea numerică, de a identifica forme
    echivalente ale unor numere și de a folosi numere pentru a reprezenta atribute ale obiectelor și cantităților
    întâlnite în viața de zi cu zi.</p>
<h4>Estimare</h4>
<p>Estimarea este procesul de a face o presupunere sau o aproximare rezonabilă unei cantități sau valori. Ea se poate
    realiza prin diverse metode, cum ar fi rotunjirea, utilizarea unor referințe (ex. compararea unei fracții cu o
    valoare cunoscută cum ar fi sfertul, jumătatea sau întregul) sau simplificarea pentru a ajunge la un răspuns
    apropiat de cel căutat, chiar dacă nu este neapărat exact. Implică, de asemenea, capacitatea de a identifica
    situațiile oportune în care estimarea este potrivită și poate fi utilă.</p>
<h4>Operații cu numere</h4>
<p>Această categorie se referă la capacitatea de a efectua operații matematice cu numere, cum ar fi adunare, scădere,
    înmulțire și împărțire, în orice situație aplicată din viața reală. Include abilități de manipulare și calcul cu
    numere, aplicarea corectă a regulilor de calcul și verificarea rezultatelor.</p>
<h4>Rapoarte și raționament proporțional</h4>
<p>Această categorie se concentrează pe înțelegerea și aplicarea corectă a
    cunoștințelor despre rapoarte și proporții. Implică abilitatea de a identifica situațiile în care proprietățile
    rapoartelor pot fi aplicate, cum ar fi regula de trei simplă.</p>`,
            `<h4>Calculul atributelor fizice</h4>
<p>Această categorie se referă la abilitatea de a estima, măsura și compara diferite proprietăți fizice ale obiectelor
    reale (masă, minge, etc.) sau teoretice (sferă, tetraedru, etc.), cum ar fi lungimea, masa, sau volumul. Include
    înțelegerea și cunoașterea termenilor care descriu dimensiunea, cum ar fi aria sau perimetrul, respectiv aplicarea
    cunoștințelor despre măsurare în contexte practice.</p>
<h4>Sisteme de măsurare </h4>
<p>Această categorie se referă la înțelegerea și utilizarea diferitelor sisteme de măsurare, cum ar fi sistemul metric.
    Include cunoașterea unităților de măsură potrivite pentru atribute specifice, capacitatea de a converti între
    unități de măsură și de a utiliza instrumente de măsurare adecvate.</p>
<h4>Calcule în triunghiuri </h4>
<p>Această categorie implică abilitatea de a calcula și înțelege relațiile
    dimensionale în triunghiuri. Elevii trebuie să cunoască, identifice și descrie diferite tipuri de unghiuri și
    triunghiuri și să cunoască și aplice cunoștințe de geometrie și/ sau trigonometrie în rezolvarea problemelor.</p>`,
            `<h4>Dimensiune și formă </h4>
<p>Această categorie se referă la identificarea și înțelegerea dimensiunilor și formelor unor obiecte geometrice reale
    (masă, scaun, etc.) sau teoretice (sferă, tetraedru, etc). Include capacitatea de a recunoaște și de a descrie
    proprietățile obiectelor geometrice în spațiu, de a diferenția obiecte variate unele de celelalte, de a aprecia
    forma, mărimea și alte caracteristici legate de un obiect și spațiul în care acesta există.</p>
<h4>Transformarea formelor și păstrarea proprietăților</h4>
<p>Această categorie se referă la înțelegerea transformărilor formelor prin procese ca răsturnarea, desfășurarea sau
    rotirea, respectiv la cunoașterea proprietăților geometrice care rămân constante în timpul acestor transformări.
    Include cunoașterea conceptelor de simetrie, congruență și similaritate și la aplicarea acestor cunoștințe în
    rezolvarea de probleme cu corpuri și figuri geometrice.</p>
<h4>Relații între figurile geometrice </h4>
<p>Această categorie se concentrează pe înțelegerea relațiilor și asemănărilor dintre diferite figuri geometrice. Elevii
    trebuie să poată identifica, descrie și folosi cunoștințe despre relațiile dintre obiecte, figuri și corpuri
    geometrice, respectiv elemente ale acestora (laturi, unghiuri, fețe, etc), cum ar fi perpendicularitatea sau
    paralelismul.</p>
<h4>Poziția, direcția și geometria coordonatelor </h4>
<p>Această categorie implică abilitatea de a înțelege și de a utiliza concepte cum ar fi poziția (sus, jos, deasupra,
    etc.), direcția (stânga, dreapta, etc.) și geometria coordonată în spațiu. Include capacitatea de a utiliza
    coordonate pentru a localiza puncte într-un sistem de referință. Conține abilități importante pentru înțelegerea
    lumii înconjurătoare, orientare în spațiu, aprecierea distanțelor și alte activități similare.</p>
<h4>Raționamentul matematic în geometrie </h4>
<p>Această categorie se referă la aplicarea raționamentului matematic orice
    context specific geometriei. Elevii trebuie să demonstreze gândire logică și abilitatea de a rezolva probleme
    complexe în geometrie, să argumenteze validitatea unor relații între elemente ale figurilor geometrice, să treacă
    mai departe de cunoașterea și aplicarea unor informații specifice geometriei, demonstrând autonomie și o strategie
    clară de rezolvare a problemelor din contexte variate.</p>`,
            `<h4>Reprezentarea datelor </h4>
<p>Această categorie implică abilitatea de a reprezenta și interpreta date folosind diferite forme de prezentare, cum ar
    fi tabelele, diagramele și grafice. Include abilitatea de a transforma datele dintr-o formă de prezentare în alta,
    de a alege cea mai eficientă metodă de prezentare pentru un scop dat și de a rezolva probleme folosind unul sau mai
    multe seturi de date.</p>
<h4>Caracteristici ale seturilor de date</h4>
<p>Această categorie se referă la înțelegerea caracteristicilor seturilor de date, atât la nivel intuitiv (ex.
    compararea seturilor de date între ele) cât și prin cunoașterea unor noțiuni de bază de statistică, cum ar fi
    indicatorii tendinței centrale (ex. medie, mediană, mod). Implică înțelegerea atât a sensului cât și a utilității
    acestor caracteristici ale datelor.</p>
<h4>Experimente și eșantioane</h4>
<p>Această categorie implică înțelegerea conceptelor legate de experimente și eșantioane în contextul colectării și
    analizei datelor. Elevii trebuie să cunoască aspecte de bază legate de experimente, eșantionare, colectarea datelor
    cantitative și să înțeleagă importanța matematicii în experimente din orice disciplină.</p>
<h4>Probabilități </h4>
<p>Această categorie se referă la înțelegerea șanselor și probabilităților unor evenimente. Include capacitatea de a
    calcula probabilitatea, de a rezolva probleme care au în centru conceptul de șansă și de a demonstra o înțelegere a
    conceptului de probabilitate în sens general. Implică înțelegerea sensului unor formulări ca: posibil, probabil,
    favorabil.</p>
<h4>Raționament matematic cu date </h4>
<p>Această categorie implică utilizarea logicii și a raționamentului matematic în contextul interpretării datelor.
    Elevii trebuie să poată extrage concluzii, să facă inferențe și să rezolve probleme bazate pe date și
    informații.</p>`,
            `<h4>Modele, relații și funcții </h4>
<p>Această categorie implică identificarea, înțelegerea și prelucrarea modelelor bazate pe reguli (ex. șiruri de numere
    formate pe baza unei reguli date), a relațiilor și a funcțiilor. Elevii trebuie să poată recunoaște și să aplice
    reguli și tipare pentru a rezolva probleme din contexte variate. </p>
<h4>Reprezentări algebrice </h4>
<p>Această categorie se referă la utilizarea simbolurilor și expresiilor algebrice pentru a reprezenta și a rezolva
    probleme. Include capacitatea de a traduce situații din limbajul comun în limbajul algebric și invers.</p>
<h4>Variabile, expresii și operații</h4>
<p>Această categorie implică înțelegerea conceptului de variabilă și aplicarea acestuia în algebră, reprezentarea și
    manipularea expresiilor algebrice și a operațiilor dintre acestea. Elevii trebuie să poată să identifice expresii
    algebrice care sunt echivalente, să aplice reguli ale operațiilor algebrice și să recunoască proprietățile
    expresiilor.</p>
<h4>Ecuații și inecuații </h4>
<p>Această categorie se concentrează pe rezolvarea și interpretarea ecuațiilor și inecuațiilor. Elevii trebuie să poată
    rezolva ecuații și inecuații, să identifice soluțiile și să rezolve probleme care au la bază conceptul de valoare
    necunoscută.</p>
<h4>Raționament matematic în algebră </h4>
<p>Această categorie se referă la utilizarea gândirii matematice în orice context
    în care lucrează cu variabile și concepte specifice algebrei. Raționamentul matematic presupune înțelegerea
    profundă, testarea și demonstrarea unor relații, iar această subcategorie de conținut se referă la aplicarea acestor
    abilități în orice situație din viața reală în care elevul lucrează cu date care nu sunt cunoscute și constante.</p>`
        ]
}
